import {cardToCardService} from "@/common/api.service"
import {cardToCardStatus} from "@/constants/cardToCard"

const initialStates = {
    status: 'loading',
    setting_status: 'loading',
    cardToCards: [],
    form_data: {},
    setting: {},
}

const mutations = {
    loading(state) {
        state.status = 'loading'
    },
    loadingSetting(state) {
        state.setting_status = 'loading'
    },
    success(state, card_to_cards) {
        state.status = 'success'
        state.card_to_cards = card_to_cards
    },
    settingSuccess(state, setting) {
        state.setting_status = 'success'
        state.setting = setting
    },
    fail(state) {
        state.status = 'fail'
        state.card_to_cards = []
    },
    setFormData(state, form_data) {
        state.status = 'setFormData'
        state.form_data = form_data
    },
    clearFormData(state) {
        state.status = 'clearFormData'
        Object.keys(state.form_data).forEach(function (key) {
            state.form_data[key] = ''
        });
    },
}

const getters = {
    status: ({status}) => status,
    cardToCards: ({cardToCards}) => cardToCards,
    setting: ({setting}) => setting,
    setting_status: ({setting_status}) => setting_status,
    form_data: ({form_data}) => form_data,
    active_card_to_cards: ({cardToCards}) => {
        if (cardToCards.data) {
            return cardToCards.data.filter(cardToCards =>
                cardToCards.status === cardToCardStatus.ACTIVE
            )
        }
        return cardToCards.filter(cardToCards =>
            cardToCards.status === cardToCardStatus.ACTIVE
        )
    }
}

const actions = {
    adminFind({commit}, hashid) {
        commit('loading')

        return cardToCardService.adminFind(hashid).then(response => {
            commit('setFormData', response.data.data)
        })
    },

    find({commit}, hashid) {
        commit('loading')

        return cardToCardService.find(hashid).then(response => {
            commit('setFormData', response.data.data)
        })
    },
    fetchSetting({commit}, hashid) {
        commit('loadingSetting')
        return cardToCardService.fetchSetting(hashid).then(response => {
            commit('settingSuccess', response.data.data)
        })
    },
    adminFetchSetting({commit}, hashid) {
        commit('loadingSetting')
        return cardToCardService.adminFetchSetting(hashid).then(response => {
            commit('settingSuccess', response.data.data)
        })
    },
    setFormData({commit}, form_data) {
        commit('setFormData', form_data)
    }
}


export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}